var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPopularProducts16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6.65271C0.447715 6.65271 0 7.10043 0 7.65271V21.6527C0 22.205 0.447715 22.6527 1 22.6527H15C15.5523 22.6527 16 22.205 16 21.6527V7.65271C16 7.10043 15.5523 6.65271 15 6.65271H1ZM14.0159 9.71489L11.8129 9.79332L7.99993 13.5953L10.1182 15.7197L13.9312 11.9177L14.0159 9.71489Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04541 0.65271C5.38856 0.65271 4.04541 1.99586 4.04541 3.65271V7.15271C4.04541 8.80956 5.38856 10.1527 7.04541 10.1527H9.68177C11.3386 10.1527 12.6818 8.80956 12.6818 7.15271V3.65271C12.6818 1.99586 11.3386 0.65271 9.68177 0.65271H7.04541ZM6.77275 2.37998C6.22046 2.37998 5.77275 2.8277 5.77275 3.37998V7.42544C5.77275 7.97772 6.22046 8.42544 6.77275 8.42544H9.95457C10.5069 8.42544 10.9546 7.97772 10.9546 7.42544V3.37998C10.9546 2.8277 10.5069 2.37998 9.95457 2.37998H6.77275Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 11.1527,
    r: 0.5,
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPopularProducts16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;